<template>
  <TechLayout>
    <div class="text-center p-3">
      <el-button-group>
        <el-button
          type="info"
          @click="$router.push('/tech')"
          style="outline:none"
          ><i class="el-icon-arrow-left"></i>技术资讯</el-button
        >
        <el-button
          type="info"
          @click="$router.push('/news')"
          style="outline:none"
          >新闻资讯<i class="el-icon-arrow-right el-icon--right"></i
        ></el-button>
      </el-button-group>
    </div>
    <!-- <div class="newsBar" >
                        <h1 class="text-right" @click="$router.push('/news')" ref="newsBar">新闻资讯</h1>
                </div>
                <div class="techBar">
                        <h1 class="text-left" @click="$router.push('/tech')">技术支持</h1>
                </div> -->

    <!-- <tech-lisence/> -->
    <div class="mt-4">
      <b-card img-left class="mb-3" v-for="(item, index) in news" :key="index">
        <b-row>
          <b-col class="col-md-6 left-pic">
            <div v-if="item.newsImg">
              <b-img class="rounded-0 card-img" :src="item.newsImg"></b-img>
            </div>
            <div v-else>
              <b-img class="rounded-0 card-img" :src="coverPic.src"></b-img>
            </div>
          </b-col>
          <b-col class="right-desc col-md-6">
            <b-card-text
              style="border-bottom: 1px solid rgb(235, 238, 245);"
              @click="$router.push(`/newsdetail/${item.newsId}`)"
            >
              <h3 class="art-title">{{ item.newsTitle }}</h3>
            </b-card-text>
            <b-card-text class="less-desc">
              {{ item.newsContent }}
            </b-card-text>
          </b-col>
        </b-row>
        <b-card-footer>
          <i class="el-icon-date">{{ item.day }}</i>
        </b-card-footer>
      </b-card>
    </div>
  </TechLayout>
</template>

<script>
import { postRequest } from "../main";
import TechLayout from "../layouts/TechNews";

export default {
  components: {
    TechLayout,
  },
  data() {
    return {
      newsdata: [
        {
          img: require("../../static/images/news_1.jpg"),
          head: " 如何辨别PVD涂层的真伪",
          update: "2019/7/5",
          body:
            "                氧化涂层：通常也称为蒸汽涂层，英文简写为VAPO，其经过高温氧化处理，色泽为深黑色，把化学元素Fe3O4经过精准的特别处理后",
        },
        {
          img: require("../../static/images/news_2.jpg"),
          head: " 如何辨别PVD涂层的真伪",
          update: "2019/5/5",
          body:
            "                氮碳化钛涂层：属于PVD涂层的范畴，英文简写为TiCN,色泽一般为蓝灰色。TiCN由于其结合了TiC和TiN的性能，既结合了TiC涂层的高硬度性，又具备",
        },
        {
          img: require("../../static/images/show_2.jpg"),
          head: " 如何辨别PVD涂层的真伪",
          update: "2018/12/25",
          body:
            "                氮碳化钛涂层：属于PVD涂层的范畴，英文简写为TiCN,色泽一般为蓝灰色。TiCN由于其结合了TiC和TiN的性能，既结合了TiC涂层的高硬度性，又具备",
        },
        {
          // img:require('../../static/images/news_1.jpg'),
          head: "  市场对高速钢锯片品质需求的改变",
          update: "2017/10/21",
          body:
            "随着中国制造业的升级，环保因素的影响，人工成本的不断上涨；企业用户自动化锯切设备的更新，对生产效率的要求，以及对高端锯片使用之后的体验，越来越多的用户和经销商朋友对于高端的圆锯片呈现渴求的态势，这对锯片生产商来说，对工匠精神的坚持无疑是极大的鼓励，也因此，浅谈这些年客户对锯片品质要求的心理接受程度的改变。",
        },
      ],
      rows: 100,
      currentPage: 1,
      news: [],
      coverPic: { src: require("../../static/Updatedimg/Corp-3.jpg") },
    };
  },
  methods: {
    getNews() {
      postRequest("http://houtai.pioneertools.com/public/getAllNews", {
        page: this.currentPage,
      }).then((res) => {
        // console.log(res);
        let data = res.data.data.list;
        for (let i = 0; i < data.length; i++) {
          let d = new Date(data[i].newsTime);
          data[i].day =
            d.getFullYear() + "-" + d.getMonth() + "-" + d.getDate();
        }
        this.news = data;
        //  this.total=res.data.data.total;
      });
    },
  },
  created() {
    this.getNews();
  },
};
</script>

<style>
.updateTime {
  color: #999;
  padding-left: 32px;
}
.newsbody {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  word-break: break-all;
}
.card {
  width: 100%;
}
.card img {
  /* width: 150px !important; */
  /* height: 150px; */
  margin-top: 35px;
}
.card-text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  word-break: break-all;
}
.newsList {
  padding-top: 10px;
}
/* .news-tech-banner{
        background: url('../../static/Updatedimg/newsbg.jpg') no-repeat;
        background-position: 50%;
        position: relative;
        background-size: cover;
        box-sizing: border-box;
        overflow: auto;
    } */
@media screen and (max-width: 768px) {
  .changebtns {
    display: block !important;
  }
  .techBar,
  .newsBar {
    display: none;
  }
}
@media screen and (min-width: 1200px) {
  .newsBar {
    height: 58px !important;
    bottom: 58px !important;
    width: 58% !important;
  }
  .techBar {
    height: 58px !important;
    bottom: 0 !important;
    width: 58% !important;
  }
  .newsBar > h1,
  .techBar > h1 {
    margin: 0;
    font-size: 30px;
    font-weight: 600;
    line-height: 58px;
    color: aliceblue;
    cursor: pointer;
    transition: all 0.8s ease-out;
  }
  .techBar > h1:hover {
    transform: translateX(0, 30px);
  }
  .newsBar > h1 {
    padding-right: 38px;
  }
  .techBar > h1 {
    padding-left: 38px;
  }
  .newsBar::after {
    border-top: 58px solid #ce181e !important;
    border-right: 58px solid transparent !important;
  }
  .newsBar::before {
    border-bottom: 58px solid #ce181e !important;
    border-left: 58px solid transparent !important;
  }
  .top-bar {
    height: 180px;
    width: 770px;
    margin: 0 auto;
  }
  .techBar::before {
    border-bottom: 58px solid #353536 !important;
    border-left: 58px solid transparent !important;
  }
  .techBar::after {
    border-top: 58px solid #353536 !important;
    border-right: 58px solid transparent !important;
  }
}

.newsBar {
  opacity: 1;
  position: absolute;
  background-color: #ce181e;
  width: 62%;
  height: 35px;
  z-index: 100;
  bottom: 35px;
}
.techBar {
  position: absolute;
  bottom: 0;
  right: 0;
  opacity: 1;
  background-color: #353536;
  width: 62%;
  height: 35px;
  z-index: 100;
}
.newsBar::before {
  content: "";
  width: 0;
  height: 0;
  opacity: 1;
  position: absolute;
  right: 100%;
  border-bottom: 35px solid #ce181e;
  border-left: 30px solid transparent;
  z-index: 100;
}

.newsBar::after {
  content: "";
  width: 0;
  height: 0;
  opacity: 1;
  position: absolute;
  left: 100%;
  top: 0;
  border-top: 35px solid #ce181e;
  border-right: 30px solid transparent;
  z-index: 100;
}
.techBar::before {
  content: "";
  width: 0;
  height: 0;
  opacity: 1;
  position: absolute;
  right: 100%;
  border-bottom: 35px solid #353536;
  border-left: 30px solid transparent;
  z-index: 100;
}
.techBar::after {
  content: "";
  width: 0;
  height: 0;
  opacity: 1;
  position: absolute;
  left: 100%;
  top: 0;
  border-top: 35px solid #353536;
  border-right: 30px solid transparent;
  z-index: 100;
}
</style>
